// Site configuration - placeholders are clearly marked; replace before launch.
export const SITE = {
  name: "Sambhav K. Pandey",
  role: "Real Estate Marketing & Advisory",
  // TODO: replace with real contact details before launch
  phone: "+91 97173 52277",
  phoneRaw: "+919717352277",
  whatsapp: "919717352277", // country code + number, no +
  email: "hello@sambhavkpandey.com", // TODO: replace with real email
  location: "Noida, Uttar Pradesh, India",
  teamSize: "200",
  socials: {
    instagram: "https://www.instagram.com/sambhavkpandey",
    facebook: "https://www.facebook.com/sambhavkpandey",
    linkedin: "https://www.linkedin.com/in/sambhavkpandey",
  },
};

export const waLink = (text = "Hi Sambhav, I'd like to know more about your projects.") =>
  `https://wa.me/${SITE.whatsapp}?text=${encodeURIComponent(text)}`;

const IMG = {
  hero: "https://images.pexels.com/photos/2887207/pexels-photo-2887207.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=1200&w=2000",
  commercial: "https://images.pexels.com/photos/23534117/pexels-photo-23534117.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=1600",
  villa: "https://images.unsplash.com/photo-1717167398817-121e3c283dbb?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2Mzl8MHwxfHNlYXJjaHw0fHxsdXh1cnklMjByZWFsJTIwZXN0YXRlJTIwZXh0ZXJpb3IlMjBtb2Rlcm58ZW58MHx8fHwxNzg0OTAwMTExfDA&ixlib=rb-4.1.0&q=85",
  noida: "https://images.unsplash.com/photo-1583009640887-eafd1a994d30?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1ODF8MHwxfHNlYXJjaHwxfHxtb2Rlcm4lMjBza3lzY3JhcGVyJTIwb2ZmaWNlJTIwYnVpbGRpbmd8ZW58MHx8fHwxNzg0OTAwMTExfDA&ixlib=rb-4.1.0&q=85",
  goa: "https://images.pexels.com/photos/35808145/pexels-photo-35808145.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  interior: "https://images.pexels.com/photos/34688219/pexels-photo-34688219.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  portrait: "https://customer-assets-cm19k8pv.emergentagent.net/job_noida-goa-properties/artifacts/rqgg23tw_0B5355D9-3C10-4084-A9F1-4D31BB6B77FF.JPG",
  portrait2: "https://customer-assets-cm19k8pv.emergentagent.net/job_noida-goa-properties/artifacts/lhy54xmx_C881C29A-F4C1-40D5-B6C7-2E7F25AEAE99.JPG",
  graama: "https://customer-assets-cm19k8pv.emergentagent.net/job_noida-goa-properties/artifacts/ay44dhoz_WhatsApp%20Image%202026-07-02%20at%2019.31.42.jpeg",
  graamaPrice: "https://customer-assets-cm19k8pv.emergentagent.net/job_noida-goa-properties/artifacts/0p284eiz_WhatsApp%20Image%202026-07-25%20at%2016.09.22.jpeg",
};

export const IMAGES = IMG;

export const PROJECTS = [
  {
    slug: "gygy-mentis",
    name: "GYGY Mentis",
    builder: "GYGY Infradesign Pvt. Ltd.",
    city: "Noida / UP",
    cityKey: "noida",
    location: "Sector 140, Noida Expressway",
    type: "Commercial · Office & Retail",
    status: "Now Selling",
    price: "On Request",
    rera: "UPRERAPRJ251909",
    tagline: "Built for generations.",
    cover: IMG.noida,
    gallery: [IMG.noida, IMG.interior, IMG.villa, IMG.goa],
    video: "https://www.youtube.com/embed/LXb3EKWsInQ",
    mapQuery: "Sector 140 Noida Expressway",
    brochure:
      "https://customer-assets-cm19k8pv.emergentagent.net/job_noida-goa-properties/artifacts/hfardjfa_%231%20MENTIS%2C%20GYGY%20Group%20Brochure.pdf",
    description:
      "A LEED Gold landmark on the Noida Expressway - a 20,000 sq.m. plot rising into 20 office floors, 2 retail floors and 2 amenity floors, designed by Design Forum International. Direct metro connectivity, 2,000-car smart parking and 100% power backup, minutes from DND and 30 minutes from the Noida International Airport.",
    highlights: [
      "LEED Gold certified",
      "20 office + 2 retail floors",
      "11.92 lakh sq.ft. built-up",
      "Direct metro connectivity",
      "2,000-car smart parking",
      "30 min to Noida Int'l Airport",
    ],
  },
  {
    slug: "urbtech-npx-sector-153",
    name: "Urbtech NPX",
    builder: "Urbtech",
    city: "Noida / UP",
    cityKey: "noida",
    location: "NPX, Sector 153, Noida Expressway",
    type: "Commercial · Business Suites & Retail",
    status: "Now Selling",
    price: "₹14,999 / sq. ft.",
    rera: "Confirm current RERA before booking",
    tagline: "Business suites with an Expressway address.",
    cover: IMG.commercial,
    gallery: [IMG.commercial, IMG.noida, IMG.interior, IMG.villa],
    video: "https://www.youtube.com/embed/LXb3EKWsInQ",
    mapQuery: "Sector 153 Noida Expressway",
    brochure:
      "https://customer-assets-cm19k8pv.emergentagent.net/job_noida-goa-properties/artifacts/gzsp7e58_NPX%20BROUCHER%20%20FINAL%20PROOF%2001.06.pdf",
    priceListUrl:
      "https://customer-assets-cm19k8pv.emergentagent.net/job_noida-goa-properties/artifacts/qo92rgq7_Urbtech_NPX_Sector153_Price_List.pdf",
    floorPlanUrl:
      "https://customer-assets-cm19k8pv.emergentagent.net/job_noida-goa-properties/artifacts/ubmk2eqz_FIFTEEN%20FLOOR-Model.pdf",
    description:
      "Urbtech NPX brings premium commercial business suites and retail to Sector 153 on the Noida Expressway - with an Expressway and Yamuna river-view frontage. Base price ₹14,999/sq. ft. on a 10-40-30-20 payment plan.",
    highlights: [
      "Business suites & retail",
      "Expressway frontage",
      "Yamuna river-view PLC",
      "10-40-30-20 payment plan",
      "Covered car parking",
      "Sector 153 location",
    ],
    pricingNote:
      "Base price ₹14,999/sq. ft. PLC: Expressway ₹500, Yamuna river-view ₹250/sq. ft. Non-refundable CRC ₹250 & additional ₹1,000/sq. ft. Covered car parking ₹7,00,000/bay. Prices subject to change - confirm before booking.",
  },
  {
    slug: "legacy-by-gaurs",
    name: "Legacy by Gaurs",
    builder: "Gaurs Group",
    city: "Noida / UP",
    cityKey: "noida",
    location: "Jaypee Greens, Sector 19 & 25, Gautam Buddha Nagar",
    type: "Residential · Luxury Homes",
    status: "Now Selling",
    price: "On Request",
    rera: "UPRERAPRJ688396/10/2024",
    tagline: "Considered luxury inside the greens.",
    cover: IMG.villa,
    gallery: [IMG.villa, IMG.interior, IMG.noida, IMG.goa],
    video: "https://www.youtube.com/embed/LXb3EKWsInQ",
    mapQuery: "Jaypee Greens Sector 25 Greater Noida",
    description:
      "Legacy by Gaurs is a refined residential address set within the established Jaypee Greens ecosystem. Expansive homes, matured landscaping and a location that pairs calm with connectivity across Gautam Buddha Nagar.",
    highlights: ["Inside Jaypee Greens", "Low-density planning", "Premium specification", "RERA registered"],
  },
  {
    slug: "sportsville-farms",
    name: "Sportsville Farms",
    builder: "Nine 'O' Nine Group",
    city: "Noida / UP",
    cityKey: "noida",
    location: "Near Sector 151, Noida",
    type: "Farmhouse Community",
    status: "Now Selling",
    price: "On Request",
    rera: "Pending - confirm before launch",
    tagline: "Far from the city hustle, close to peace.",
    cover: IMG.interior,
    gallery: [IMG.interior, IMG.villa, IMG.goa, IMG.noida],
    video: "https://www.youtube.com/embed/LXb3EKWsInQ",
    mapQuery: "Sector 151 Noida",
    brochure:
      "https://customer-assets-cm19k8pv.emergentagent.net/job_noida-goa-properties/artifacts/iaool2bg_Sportsville%20Farms%20Brochure.pdf",
    description:
      "A farmhouse community by the Nine 'O' Nine Group near Sector 151, Noida - where nature greets you with open arms. Over 400 farmhouses and 250+ acres already delivered, with a 24x7 sports complex, open green spaces and a 4-lane expressway that puts Connaught Place under 35 minutes away.",
    highlights: [
      "400+ farmhouses delivered",
      "250+ acres developed",
      "24x7 sports complex",
      "Under 35 min from Connaught Place",
      "4-lane expressway connectivity",
      "Metro access on the Expressway",
    ],
  },
  {
    slug: "anandam-homes-goa",
    name: "Anandam Homes",
    builder: "Vedic City",
    city: "Goa (Konkan)",
    cityKey: "goa",
    location: "Vedic City, Konkan (near Goa)",
    type: "Villa Plots",
    status: "Now Selling",
    price: "₹21,500 / sq. yd. (base)",
    rera: "Pending - confirm before launch",
    tagline: "Live the balance.",
    cover: IMG.goa,
    gallery: [IMG.goa, IMG.villa, IMG.interior, IMG.noida],
    video: "https://www.youtube.com/embed/LXb3EKWsInQ",
    mapQuery: "Kudal Sindhudurg Maharashtra",
    brochure:
      "https://customer-assets-cm19k8pv.emergentagent.net/job_noida-goa-properties/artifacts/i8npixs3_Anandam%20homes%20by%20VC.pdf",
    description:
      "An affordable-luxury plotted community by Vedic City, spread across 46 acres in the Konkan belt near Goa. 240 & 300 sq. yd. villa plots with only 60% plotted area - the rest given to central lawns, jogging tracks, tree-lined avenues and community plazas. Phase One targeted for 2026.",
    highlights: [
      "Spread across 46 acres",
      "240 & 300 sq. yd. plots",
      "Only 60% plotted - 40% open/green",
      "Central lawn & jogging track",
      "Rainwater harvesting & recharge",
      "Phase One · 2026",
    ],
    pricingNote: "Base ₹21,500/sq. yd. EDC/IDC and IFMS charged separately. Prices indicative - confirm current pricing before booking.",
  },
  {
    slug: "graama-vedic-city",
    name: "GRAAMA · Vedic City",
    builder: "Ebrix Infratech Real Estate LLP",
    city: "Goa (Konkan)",
    cityKey: "goa",
    location: "Vedic City, Kudal, Sindhudurg (near Goa)",
    type: "Villa Plots · Plotted Development",
    status: "Now Selling",
    price: "₹87 Lakhs onwards",
    rera: "PP1310002502621 (MahaRERA · valid till 31 Dec 2028)",
    tagline: "RERA-certified villa plots in the Konkan, at Goa's doorstep.",
    cover: IMG.goa,
    gallery: [IMG.goa, IMG.graama, IMG.graamaPrice, IMG.villa],
    video: "https://www.youtube.com/embed/LXb3EKWsInQ",
    mapQuery: "Kudal Sindhudurg Maharashtra",
    brochure:
      "https://customer-assets-cm19k8pv.emergentagent.net/job_noida-goa-properties/artifacts/9bi16kdx_Graama%2028.Nov.pdf",
    rearaCertificate:
      "https://customer-assets-cm19k8pv.emergentagent.net/job_noida-goa-properties/artifacts/xlq2v377_1772712807059_ProjectRegistrationCertificate.pdf",
    description:
      "GRAAMA by Vedic City is a RERA-certified plotted development at Kudal, Sindhudurg - in the Konkan belt on Goa's doorstep. A sanctioned layout of 57 villa plots on a transparent 30-30-30-10 payment plan, limited inventory, with basic price from ₹34,500/sq. yd.",
    highlights: [
      "MahaRERA certified (PP1310002502621)",
      "57-plot sanctioned layout",
      "Limited inventory",
      "30-30-30-10 payment plan",
      "Basic price ₹34,500/sq. yd.",
      "Konkan location near Goa",
    ],
    pricingNote:
      "Basic price ₹34,500/sq. yd. EDC/IDC pro-rated at ₹490/sq. yd; IFMS ₹150/sq. yd; PLC 10% & 15%. Stamp duty & registration at prevailing rates. Effective 15 Mar 2026 - subject to change. Payments only to Ebrix Infratech Real Estate LLP.",
  },
];

export const getProject = (slug) => PROJECTS.find((p) => p.slug === slug);

export const PARTNERS = [
  "GYGY Group",
  "Gaurs Group",
  "Max Estates",
  "Vedic City",
  "Jaypee Greens",
  "Nine 'O' Nine",
];

export const TESTIMONIALS = [
  {
    quote:
      "I'd been circling the Expressway market for a year, second-guessing every builder. Sambhav's team walked me through the RERA filing line by line and drove me to three sites in a single afternoon. I closed on Legacy by Gaurs the same week - no pressure, just clarity.",
    name: "Rohan Mehta",
    detail: "First-time investor · Noida",
  },
  {
    quote:
      "Buying land in the Konkan from Bengaluru could have been a nightmare. What won me over was how the EDC, IDC and IFMS were shown as separate line items instead of buried in a round number. That honesty is rare - I referred two colleagues before I'd even registered my own plot.",
    name: "Priya Nair",
    detail: "NRI buyer · Bengaluru → Goa/Konkan",
  },
  {
    quote:
      "We handed Sambhav a plotted project that three other channel partners had stalled on. His 200-person team had qualified walk-ins within a fortnight and a sold-out phase soon after. He understands the product as well as my own project head does.",
    name: "Anurag Verma",
    detail: "Developer partner · NCR",
  },
  {
    quote:
      "What I remember most is the follow-up. Every WhatsApp got a reply, every document arrived when promised, and nobody vanished after the booking. For a commercial suite at Urbtech NPX, that after-sales discipline mattered more than the discount.",
    name: "Kavita Bansal",
    detail: "Commercial buyer · Sector 153, Noida",
  },
  {
    quote:
      "I compared farmhouse options for months. Sambhav never oversold - he actually talked me out of a plot that didn't fit my budget and pointed me to a better-value one. That single honest conversation is why my extended family now buys only through him.",
    name: "Deepak Sikarwar",
    detail: "Repeat client · Sportsville Farms",
  },
];

export const SOCIAL_POSTS = [
  { type: "reel", url: "https://www.instagram.com/reel/DaseeUxTZ0_/" },
  { type: "reel", url: "https://www.instagram.com/reel/DbNlnrqTIx1/" },
  { type: "post", url: "https://www.instagram.com/p/DZg7df0ga0x/" },
];

// LinkedIn Insights - curated cards. Set each `url` to a specific LinkedIn post when available.
export const INSIGHTS = [
  {
    tag: "Market Note",
    readTime: "3 min read",
    title: "Why Jewar Airport is rewriting the Noida Expressway map",
    excerpt:
      "The Noida International Airport at Jewar isn't just an airport - it's the single biggest demand driver for plotted and commercial real estate along the Expressway. Here's how I'm reading the corridor.",
    url: "https://www.linkedin.com/in/sambhavkpandey",
  },
  {
    tag: "Advisory",
    readTime: "4 min read",
    title: "Reading a plot price the right way: base, EDC, IDC, IFMS",
    excerpt:
      "The number that matters isn't the headline rate - it's the all-in cost. A quick field guide to the line items every plotted-development buyer should demand to see separately.",
    url: "https://www.linkedin.com/in/sambhavkpandey",
  },
  {
    tag: "On the Ground",
    readTime: "2 min read",
    title: "Building a 200-person sales engine that developers trust",
    excerpt:
      "Speed of follow-up, honest documentation and product knowledge - the three things that turn a sales team into a partner developers come back to. Notes from running mine.",
    url: "https://www.linkedin.com/in/sambhavkpandey",
  },
];

export const PROPERTYLAY = {
  name: "Propertylay",
  founder: "Jyoti Pandey & Chirag Vohra",
  tagline: "Unlock your dream property with Propertylay.",
  logo: "https://www.propertylay.com/assets/images/logo.jpg",
  url: "https://www.propertylay.com/",
  description:
    "Founded by Jyoti Pandey & Chirag Vohra, Propertylay specialises in luxury estate farmhouses, villas and premium plots - carefully selected, high-value projects that combine luxury, greenery and long-term growth.",
  services: ["Luxury Farm Plots", "Villas", "Premium Plots"],
  phone: "+91 99537 68643",
  phoneRaw: "+919953768643",
  email: "contactus@propertylay.com",
  address: "Insignia Tower, 2nd Floor, Sector 126, Noida",
  instagram: "https://www.instagram.com/propertylay_",
};

export const STATS = [
  { value: "200+", label: "Sales professionals" },
  { value: "2", label: "High-growth markets" },
  { value: "6+", label: "Active developments" },
  { value: "12+", label: "Years in the field" },
];
